module.exports = __webpack_public_path__ + "media/img/up-icon-blue-97aa27c516fc7d8a9e5d8d21e727f82c.svg";